// QESG ASSESSMENT 중 관리자 화면의 '프로젝트 코드별 view' 관련 Store
import axios from '@core_utils/api/_axios.js'

const project_code = {
    namespaced: true,
    state: {
        now_project: {},
        project_codes: [],
        is_project_codes_loaded: false,
        project_companies: [],
        is_project_companies_loaded: false,
        data_quality_description: [
            {
                level: "Lv1. 자가진단",
                description: '기업이 입력한 답변에 대해 평가자가 별도의 확인 및 검증 과정 없이 결과를 산출한 것으로, 기업 답변의 신뢰성에 의존하여 평가된 결과입니다.',
            },
            {
                level: "Lv2. 서면평가",
                description: '기업이 제출한 답변에 대해 독립적인 제3자 평가자가 답변의 신뢰성과 타당성에 대해 합리적인 수준에서 확인 과정을 거친 후 결과를 산출한 것으로, 기업 답변의 신뢰성에 더하여 제3자 평가가 진행된 결과입니다.',
            },
            {
                level: "Lv3. 현장평가",
                description: '독립적인 제3자 평가자가 기업을 직접 방문하여 기업이 입력 및 제출한 답변에 대해 심층적인 수준에서 확인 과정을 거친 후 결과를 산출한 것으로, 가장 높은 수준의 신뢰도로 평가한 결과입니다.',
            }
        ],

    },
    getters: {
        data_lv_description(state) {
            if (state.now_project.data_quality) {
                let idx = state.data_quality_description.findIndex(x => x.level == state.now_project.data_quality)
                if (idx > -1) {
                    return state.data_quality_description[idx].description
                } else {
                    return '-'
                }
            } else {
                return '-'
            }
        }
    },
    mutations: {
        update_custom_project_codes_list(state, new_list) {
            state.project_codes = new_list
        },
        update_is_project_codes_loaded(state, flag) {
            state.is_project_codes_loaded = flag
        },
        update_is_project_companies_loaded(state, flag) {
            state.is_project_companies_loaded = flag
        },
        update_project_companies(state, new_list) {
            state.project_companies = new_list
        },
        update_now_project(state, new_project) {
            state.now_project = new_project
        }

    },
    actions: {
        async readProjectCodes({commit}, user_id) {
            try {
                // const response = await axios.get('/read_project_codes', { params: { user_id }})
                const response = await axios.get('/projects', {params: {user_id}})
                commit('update_custom_project_codes_list', response.data)
                commit('update_is_project_codes_loaded', true)
            } catch (error) {
                return Promise.reject(error)
            }
        },
        async readSingleProjectCode({commit}, {project_code, user_id}) {
            try {
                const response = await axios.get('/projects', {params: {user_id, project_code}})
                commit('update_now_project', response.data?.[0] ?? {})
            } catch (error) {
                return Promise.reject(error)
            }
        },
        async readProjectCompaniesCampaigns({commit}, project_code) {
            const response = await axios.get('/read_project_companies_campaigns', {
                params: {project_code}
            })
            commit('update_project_companies', response.data)
            commit('update_is_project_companies_loaded', true)
        },
        async readSingleProjectCompaniesCampaign({commit}, {project_code, company_id}) {
            const response = await axios.get('/read_project_companies_campaigns', {
                params: {project_code, company_id}
            })
            commit('update_project_companies', response.data)
            commit('update_is_project_companies_loaded', true)
        },
        async progressSendEmail({commit}, {company_id, campaign_id, e_mail, mail_to_option, title, contents}) {
            let formData = new FormData()
            formData.append('company_id', company_id)
            formData.append('campaign_id', campaign_id)
            formData.append('e_mail', e_mail)
            formData.append('mail_to_option', mail_to_option)
            formData.append('title', title)
            formData.append('contents', contents)
            const response = await axios.post('/progress_send_email', formData)
            return response.data

        }
    }
}

export default project_code
